// import PropTypes from 'prop-types';
// import { useState } from 'react';

// // react-bootstrap
// import Button from 'react-bootstrap/Button';
// import Col from 'react-bootstrap/Col';
// import Form from 'react-bootstrap/Form';
// import Image from 'react-bootstrap/Image';
// import InputGroup from 'react-bootstrap/InputGroup';
// import Row from 'react-bootstrap/Row';
// import Stack from 'react-bootstrap/Stack';

// // third-partyA
// import { useForm } from 'react-hook-form';

// // project-imports
// import MainCard from '../components/MainCard.jsx';
// import { confirmPasswordSchema, emailSchema, firstNameSchema, lastNameSchema, passwordSchema } from '../utils/validationSchema';

// // assets
// import DarkLogo from '../assets/images/logo-dark.svg';

// // ==============================|| AUTH REGISTER FORM ||============================== //

// export default function AuthRegisterForm({ className, link }) {
//   const [showPassword, setShowPassword] = useState(false);
//   const {
//     register,
//     handleSubmit,
//     reset,
//     formState: { errors },
//     setError,
//     clearErrors
//   } = useForm();

//   const togglePasswordVisibility = () => {
//     setShowPassword((prevState) => !prevState);
//   };

//   const onSubmit = (data) => {
//     if (data.password !== data.confirmPassword) {
//       setError('confirmPassword', {
//         type: 'manual',
//         message: 'Both Password must be match!'
//       });
//     } else {
//       clearErrors('confirmPassword');
//       reset();
//     }
//   };

//   return (
//     <MainCard className="mb-0">
//       <div className="text-center">
//         <a>
//           <Image src={DarkLogo} alt="img" />
//         </a>
//       </div>
//       <Form onSubmit={handleSubmit(onSubmit)}>
//         <h4 className={`text-center f-w-500 mt-4 mb-3 ${className}`}>Sign up</h4>
//         <Row>
//           <Col sm={6}>
//             <Form.Group className="mb-3" controlId="formFirstName">
//               <Form.Control
//                 type="text"
//                 placeholder="First Name"
//                 {...register('firstName', firstNameSchema)}
//                 isInvalid={!!errors.firstName}
//                 className={className && 'bg-transparent border-white text-white border-opacity-25 '}
//               />
//               <Form.Control.Feedback type="invalid">{errors.firstName?.message}</Form.Control.Feedback>
//             </Form.Group>
//           </Col>
//           <Col sm={6}>
//             <Form.Group className="mb-3" controlId="formLastName">
//               <Form.Control
//                 type="text"
//                 placeholder="Last Name"
//                 {...register('lastName', lastNameSchema)}
//                 isInvalid={!!errors.email}
//                 className={className && 'bg-transparent border-white text-white border-opacity-25 '}
//               />
//               <Form.Control.Feedback type="invalid">{errors.lastName?.message}</Form.Control.Feedback>
//             </Form.Group>
//           </Col>
//         </Row>
//         <Form.Group className="mb-3" controlId="formEmail">
//           <Form.Control
//             type="email"
//             placeholder="Email Address"
//             {...register('email', emailSchema)}
//             isInvalid={!!errors.email}
//             className={className && 'bg-transparent border-white text-white border-opacity-25 '}
//           />
//           <Form.Control.Feedback type="invalid">{errors.email?.message}</Form.Control.Feedback>
//         </Form.Group>
//         <Form.Group className="mb-3" controlId="formPassword">
//           <InputGroup>
//             <Form.Control
//               type={showPassword ? 'text' : 'password'}
//               placeholder="Password"
//               {...register('password', passwordSchema)}
//               isInvalid={!!errors.password}
//               className={className && 'bg-transparent border-white text-white border-opacity-25 '}
//             />
//             <Button onClick={togglePasswordVisibility}>
//               {showPassword ? <i className="ti ti-eye" /> : <i className="ti ti-eye-off" />}
//             </Button>
//             <Form.Control.Feedback type="invalid">{errors.password?.message}</Form.Control.Feedback>
//           </InputGroup>
//         </Form.Group>
//         <Form.Group className="mb-3" controlId="formConfirmPassword">
//           <Form.Control
//             type="password"
//             placeholder="Confirm Password"
//             {...register('confirmPassword', confirmPasswordSchema)}
//             isInvalid={!!errors.confirmPassword}
//             className={className && 'bg-transparent border-white text-white border-opacity-25 '}
//           />
//           <Form.Control.Feedback type="invalid">{errors.confirmPassword?.message}</Form.Control.Feedback>
//         </Form.Group>
//         <Stack direction="horizontal" className="mt-1 justify-content-between">
//           <Form.Group controlId="customCheckc1">
//             <Form.Check
//               type="checkbox"
//               label="I agree to all the Terms & Condition"
//               defaultChecked
//               className={`input-primary ${className ? className : 'text-muted'} `}
//             />
//           </Form.Group>
//         </Stack>
//         <div className="text-center mt-4">
//           <Button type="submit" className="shadow px-sm-4">
//             Sign up
//           </Button>
//         </div>
//         <Stack direction="horizontal" className="justify-content-between align-items-end mt-4">
//           <h6 className={`f-w-500 mb-0 ${className}`}>Already have an Account?</h6>
//           <a href={link} className="link-primary">
//             Login
//           </a>
//         </Stack>
//       </Form>
//     </MainCard>
//   );
// }

// AuthRegisterForm.propTypes = { className: PropTypes.string, link: PropTypes.string };

import { useState } from "react";
import { useForm } from "react-hook-form";
import { Link, useNavigate } from "react-router-dom";
import {
  emailSchema,
  passwordSchema,
  confirmPasswordSchema,
  firstNameSchema,
  lastNameSchema,
} from "../utils/validationSchemas";

export default function AuthRegisterForm() {
  const [successMessage, setSuccessMessage] = useState("");
  const navigate = useNavigate();

  const { register, handleSubmit, watch, formState: { errors } } = useForm({
    mode:"onChange",
  });

  const [showPassword, setShowPassword] = useState(false);
const [showConfirmPassword, setShowConfirmPassword] = useState(false);

  const onSubmit = (data) => {
    setSuccessMessage("Registration Successful!");
    setTimeout(() => navigate("/"), 1000);
  };

  return (
    <div className="auth-main">
      <div className="auth-wrapper v1">
        <div className="auth-form">
          <div className="position-relative">
            <div className="auth-bg">
              <span className="r" />
              <span className="r s" />
              <span className="r s" />
              <span className="r" />
            </div>
            <div className="mb-0 card">
              <div className="card-body">
                <div className="text-center">
                  <a>
                    <img
                      src="/demos/admin-templates/datta-able/react/free/assets/logo-dark-CBiufvjh.svg"
                      alt="img"
                    />
                  </a>
                </div>
                <form onSubmit={handleSubmit(onSubmit)}>
                  <h4 className="text-center f-w-500 mt-4 mb-3">Sign up</h4>

                  <div className="row">
                    <div className="col-sm-6">
                      <div className="mb-3">
                        <input
                          placeholder="First Name"
                          type="text"
                          {...register("firstName", firstNameSchema)}
                          className={`form-control ${errors.firstName ? "is-invalid" : ""}`}
                        />
                        <div className="invalid-feedback">{errors.firstName?.message}</div>
                      </div>
                    </div>
                    <div className="col-sm-6">
                      <div className="mb-3">
                        <input
                          placeholder="Last Name"
                          type="text"
                          {...register("lastName", lastNameSchema)}
                          className={`form-control ${errors.lastName ? "is-invalid" : ""}`}
                        />
                        <div className="invalid-feedback">{errors.lastName?.message}</div>
                      </div>
                    </div>
                  </div>

                  <div className="mb-3">
                    <input
                      placeholder="Email Address"
                      type="email"
                      {...register("email", emailSchema)}
                      className={`form-control ${errors.email ? "is-invalid" : ""}`}
                    />
                    <div className="invalid-feedback">{errors.email?.message}</div>
                  </div>

                  <div className="mb-3">
                    <div className="input-group">
                      <input
                        placeholder="Password"
                        type={showPassword ? "text" : "password"}
                        {...register("password", passwordSchema)}
                        className={`form-control ${errors.password ? "is-invalid" : ""}`}
                      />
                      <button type="button" className="btn btn-primary"
                       onClick={() => setShowPassword(!showPassword)}
                      >
                        <i className={showPassword ? "ti ti-eye" : "ti ti-eye-off"} />
                      </button>
                      <div className="invalid-feedback">{errors.password?.message}</div>
                    </div>
                  </div>

                  <div className="mb-3">
                    <input
                      placeholder="Confirm Password"
                      type="password"
                      {...register("confirmPassword", {
                        ...confirmPasswordSchema,
                        validate: (value) =>
                          value === watch("password") || "Passwords do not match",
                      })}
                      className={`form-control ${errors.confirmPassword ? "is-invalid" : ""}`}
                    />
                    <div className="invalid-feedback">{errors.confirmPassword?.message}</div>
                  </div>

                  <div className="mt-1 justify-content-between hstack">
                    <div className="input-primary text-muted form-check">
                      <input
                        type="checkbox"
                        id="customCheckc1"
                        {...register("terms", { required: "You must agree to the Terms & Conditions" })}
                        className={`form-check-input ${errors.terms ? "is-invalid" : ""}`}
                      />
                      <label htmlFor="customCheckc1" className="form-check-label">
                        I agree to all the Terms & Conditions
                      </label>
                      <div className="invalid-feedback">{errors.terms?.message}</div>
                    </div>
                  </div>

                  {successMessage && (
                    <div className="alert alert-success mt-3">{successMessage}</div>
                  )}

                  <div className="text-center mt-4">
                    <button type="submit" className="shadow px-sm-4 btn btn-primary">
                      Sign up
                    </button>
                  </div>

                  <div className="justify-content-between align-items-end mt-4 hstack">
                    <h6 className="f-w-500 mb-0">Already have an Account?</h6>
                    <Link to="/" className="link-primary">Login</Link>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

